// index.js
import en from './en.json'
import nl from './nl.json'
import fr from './fr.json'
import pt from './pt.json'
import es from './es.json'
import de from './de.json'
import it from './it.json'
import da from './da.json'
import lb from './lb.json'
import cy from './cy.json'
import et from './et.json'
import fi from './fi.json'
import lt from './lt.json'
import lv from './lv.json'
import nb from './nb.json'
import pl from './pl.json'
import ro from './ro.json'
import sv from './sv.json'
import tr from './tr.json'
import cs from './cs.json'
import hu from './hu.json'
import sk from './sk.json'
import bg from './bg.json'

export const languages = {
    en: en,
    nl: nl,
    fr: fr,
    pt: pt,
    es: es,
    de: de,
    it: it,
    da: da,
    lb: lb,
    cy: cy,
    et: et,
    fi: fi,
    lt: lt,
    lv: lv,
    nb: nb,
    pl: pl,
    ro: ro,
    sv: sv,
    tr: tr,
    cs: cs,
    hu: hu,
    sk: sk,
    bg: bg,
};